import { parse } from 'cookie';

// Server-side cookie helper

export const parseServerCookies = (cookieString) => {
  if (!cookieString || typeof cookieString !== 'string') return {};

  try {
    return cookieString
      .split(';')
      .reduce((cookies, cookie) => {
        const [name, value] = cookie.trim().split('=');
        if (name && value) {
          cookies[name] = decodeURIComponent(value);
        }
        return cookies;
      }, {});
  } catch (error) {
    console.error('Error parsing cookies:', error);
    return {};
  }
};

export const getServerSideToken = (req) => {
  if (!req || !req.headers.cookie) return null;

  const cookies = parseServerCookies(req.headers.cookie);
  return cookies.userToken || null;
};
// Client-side cookie helper
export const getClientSideToken = () => {
  if (typeof window === 'undefined') return null;

  const value = `; ${document.cookie}`;
  const parts = value.split('; userToken=');
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
};
// Universal token getter
export const getAuthToken = (req = null) => {
  if (typeof window === 'undefined') {
    // Server-side
    return getServerSideToken(req);
  }
  // Client-side
  return getClientSideToken();
};

// Set/clear token helpers
export const setAuthToken = (token, options = {}) => {
  if (typeof window === 'undefined') return;

  const defaultOptions = {
    maxAge: 60 * 60 * 24 * 7, // 7 days
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    path: '/',
    ...options,
  };

  let cookieString = `userToken=${token}; path=${defaultOptions.path}`;

  if (defaultOptions.maxAge) {
    cookieString += `; max-age=${defaultOptions.maxAge}`;
  }

  if (defaultOptions.secure) {
    cookieString += '; secure';
  }

  if (defaultOptions.sameSite) {
    cookieString += `; samesite=${defaultOptions.sameSite}`;
  }

  document.cookie = cookieString;
};
export const clearAuthToken = () => {
  if (typeof window === 'undefined') return;

  document.cookie = 'userToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
};

// Server-side cookie clearing
export const clearServerSideAuthToken = (res) => {
  if (!res) return;

  res.setHeader('Set-Cookie', 'userToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; HttpOnly; SameSite=Lax');
};

export const isAuthenticated = (req = null) => {
  const token = getAuthToken(req);
  return !!token;
};
